export function calculateIfMemberHasPartner(value: string | null | undefined, isSkipped: boolean): "YES" | "NO" | null {
  if (typeof value === "undefined" || value === null || !value.trim()) {
    return isSkipped ? "NO" : null
  }
  return isSkipped ? "NO" : "YES"
}
